import { ActivityStreamState } from '@coin/shared/activity-stream/feature';
import { UserState } from '@coin/shared/auth/feature';

export const AdminAppState = [UserState, ActivityStreamState];
